import React from "react";

export const siteData = {
  profile: {
    name: "Kelvin Li",
    photo: "/images/profile.jpg",
    description: (
      <>
        I am a 5th-Year M.S. student in EECS at UC Berkeley, where I
        previously studied EECS and Mathematics as an undergraduate. I am
        advised by{" "}
        <a
          href="https://roeiherz.github.io/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 transition-colors hover:text-orange-500"
        >
          Roei Herzig
        </a>{" "}
        and{" "}
        <a
          href="https://people.eecs.berkeley.edu/~trevor/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 transition-colors hover:text-orange-500"
        >
          Prof. Trevor Darrell
        </a>
        .
      </>
    ),
  },

  socialLinks: [
    {
      label: "Email",
      href: "mailto:kelvin.li.jm@gmail.com",
    },
    {
      label: "LinkedIn",
      href: "https://www.linkedin.com/in/kelvin-li-jm/",
    },
    {
      label: "Google Scholar",
      href: "https://scholar.google.com/citations?user=2sCyIbYAAAAJ&hl=en&oi=sra",
    },
  ],

  publications: [
      {
      id: "dwm-emnlp-2026",
      title: "Discriminative World Models for Web Agents",
      venue: "EMNLP 2026 (Findings) · * Equal contribution",
      authors: [
        { name: "Kelvin Li", equal: true },
        { name: "Dhruv Pendharkar", equal: true },
        { name: "Anish Pahilajani" },
        { name: "Chuyi Shang" },
        { name: "Leon Oks" },
        { name: "Leonid Karlinsky" },
        { name: "Rogerio Feris" },
        { name: "Trevor Darrell" },
        { name: "Roei Herzig" },
      ],
      links: [
        {
          label: "arXiv",
          href: "https://arxiv.org/abs/2609.02885",
        },
      ],
      description:
        "DWM explores how world models can learn what to represent for decision-making, rather than reproducing a predefined representation of the next state. By learning to distinguish the consequences of different actions, it produces representations that help web agents compare alternatives and choose better actions.",
      image: "/images/dwm_teaser.png", 
    },
    {
      id: "livr-cvpr-2026",
      title: "Latent Implicit Visual Reasoning",
      venue: "CVPR 2026 · * Equal contribution",
      authors: [
        { name: "Kelvin Li", equal: true },
        { name: "Chuyi Shang", equal: true },
        { name: "Leonid Karlinsky" },
        { name: "Rogerio Feris" },
        { name: "Trevor Darrell" },
        { name: "Roei Herzig" },
      ],
      links: [
      {
        label: "arXiv",
        href: "https://arxiv.org/abs/2512.21218",
      },
      {
        label: "Project",
        href: "https://www.chuyishang.com/livr/",
      },
    ],
      description:
        "LIVR explores how multimodal models can learn to form and reason over abstract visual representations on their own, rather than relying on explicit human-designed intermediate visual reasoning steps.",
      image: "/images/livr_teaser.png",
    },
  ],

  teaching: [
    {
      id: "cs180-fall-2026",
      role: "Teaching Assistant",
      course: "CS 180: Computer Vision and Computational Photography",
      href: "https://cal-cs180.github.io/fa26/",
      institution: "UC Berkeley",
      term: "Fall 2026",
      instructors: [
        {
          name: "Alexei A. Efros",
          href: "https://people.eecs.berkeley.edu/~efros/",
        },
        {
          name: "Ren Ng",
          href: "https://www2.eecs.berkeley.edu/Faculty/Homepages/yirenng.html",
        },
      ],
    },
  ],

  academicService: [
    {
      role: "Reviewer",
      venues: [
        { name: "ECCV", year: "2026" },
        { name: "ICLR", year: "2027" },
      ],
    },
  ],
  
};
